import './Spinner.css'
const Spinner = () => { 
    return (
        <div className='loader-container'>
            <div className="loader" />
        </div>
    )
}

export default Spinner;